import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid,  TextField } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { searchCompanyEmployees, setApprovalEmployees } from "../../store/slices/userRequests";
import { NewNodeData } from ".";
import MyTextField from "../../components/MyTextField";
import { ApprovalGroupsCompanies } from "../../interfaces/auth.interface";
import { setOrganizationEmployee, setOrganizationOffice } from "../../api/s10OrganizationApi";
import { Office } from "../../interfaces/s10Corporation.interface";


type nodeAction =  "Agregar" | "Modificar";

interface AddNodeModalProps {
    company: ApprovalGroupsCompanies;
    nodeAction: nodeAction;
    parentData: Office | null;
    nodesData: Office[];
    onCancel: () => void;
    setNewNodeResult: (data: NewNodeData) => void,
}

const AddNodeModal = ({nodeAction, onCancel, company, setNewNodeResult, parentData, nodesData}: AddNodeModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const {connectionId} = useSelector((state: RootState) => state.auth);
    const {employees, loading} = useSelector((state: RootState) => state.userRequests).companyEmployees;
    const [query, setQuery] = useState<string>('');
    const [officeName, setOfficeName] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [isPrincipal, setIsPrincipal] = useState<boolean>(false);
    const [nodesEmployees, setNodesEmployees] = useState<any[]>([]);
    
    useEffect(() => {
        if (loading || !connectionId || !company || parentData?.currentChildView !== "employees") {
            return;
        }
        dispatch(searchCompanyEmployees(company.RUC, 10, 1, query))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    useEffect(() => {
        let employeesIds: any[] = []
        for (let i = 0; i < nodesData.length; i++) {
            const node = nodesData[i];
            if (node.Employees?.length) {
                for (let ii = 0; ii < node.Employees.length; ii++) {
                    const employee = node.Employees[ii];
                    employeesIds.push({
                        ...employee,
                        Name: node.Name,
                    })
                }
            }
        }
        setNodesEmployees(employeesIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodesData]);
    
    useEffect(() => {
        if (employees.length === 1 && query === employees[0].Descripcion) {
            const employeExists = nodesEmployees
                .find(n => n.EmployeeCode === employees[0].CodIdentificador && parentData?.Id === n.parentData.Id);
            console.log(employeExists)
            if (employeExists) {
                setError(`El colaborador ya pertenece a ${employeExists.Name}`)
            }
        } else {
            setError("")
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employees]);

    const handleSaveNewEmployee = async () => {

        const result = await setOrganizationEmployee(
            parentData?.Id as any, 
            isPrincipal, 
            [employees[0].CodIdentificador]
        );
        if (result?.data?.Type !== 0) {
            setNewNodeResult({
                success: false,
                message: result?.data?.Message || "Ocurrió un error registrando el colaborador",
                action: parentData?.currentChildView as any,
            });
            return;
        }
        dispatch(setApprovalEmployees({
            data: employees as any,
            count: 1,
            part: 1,
        }));
        const employeeResult = result.data.Value.Employees[0]
        console.log(result?.data.Value)
        setNewNodeResult({
            success: true,
            message: "Colaborador creado",
            employeeData: {
                ...employees[0] as any,
                Id: employeeResult.Id,
                EmployeeCode: employees[0].CodIdentificador,
                IsPrincipal: isPrincipal,
                parentData: parentData,
                parents: [...parentData?.parents || [], parentData?.Id]
            },
            action: parentData?.currentChildView as any,
        });
    }

    const handleSaveNewOffice = async () => {

        const result = await setOrganizationOffice(company, parentData?.Id as any, officeName);
        console.log(result)
        if (result?.data?.Type !== 0) {
            setNewNodeResult({
                success: false,
                message: result?.data?.Message || "Ocurrió un error registrando la gerencia",
                action: parentData?.currentChildView as any,
            });
            return;
        }
        setNewNodeResult({
            success: true, 
            message: "Gerencia creada",
            officeData: {
                Id: result?.data?.Value?.Id,
                Name: officeName,
                parentData: parentData as any,
                parents: [...(parentData as any).parents || [], (parentData as any).Id],
                Order: null, 
                ParentId: (parentData as any).Id, 
                IsActive: true, 
                Collaborators: [],
            },
            action: parentData?.currentChildView as any,
        });
    }
    

    return (<Dialog
        open={true}
        aria-labelledby="responsive-dialog-title"
        style={{width: "100%"}}
    >
        <DialogTitle
            id="responsive-dialog-title" 
            style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
            variant="h5"
        >
            {nodeAction}{" "}{parentData?.currentChildView === "employees" ? "colaborador" : "gerencia"}
        </DialogTitle>
        <DialogContent style={{width: "25rem", textAlign: "center"}}>
            <Grid container spacing="1.5rem">
                <Grid item xs={12} style={{maxWidth: "25rem"}}>
                    
                    {parentData?.currentChildView === "employees" 
                        ? <FormControl error={!!error} fullWidth >
                            <Autocomplete
                                freeSolo
                                size="small"
                                fullWidth
                                options={employees.map(e => e.Descripcion)}
                                onInputChange={(event: React.ChangeEvent<{}>, value: string) =>
                                    setQuery(value)
                                }
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label="Buscar colaborador"
                                    variant="outlined"
                                    error={!!error}
                                    />
                                )}
                            />
                            {error && <FormHelperText id="collaborator-search-error">{error}</FormHelperText>}
                        </FormControl>
                        : <MyTextField
                            style={{width: "100%"}} 
                            label="Nombre gerencia"
                            onChange={({target}) => setOfficeName(target.value)}
                            value={officeName}
                        />
                    }
                </Grid>
                {parentData?.currentChildView === "employees" && 
                    <Grid item xs={12} textAlign="start" style={{paddingTop: 0}}>
                        <FormControlLabel 
                            control={<Checkbox
                                onChange={(_, checked) => {
                                    setIsPrincipal(checked)
                                }}
                                checked={isPrincipal} 
                            />} 
                            label="Responsable"
                        />
                    </Grid>
                }
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid 
                container 
                direction="row"
                justifyContent="space-between"
                margin={"0.5rem 1rem 2rem 1rem"}
            >
                <Grid item >
                    <Button
                        variant="outlined" 
                        style={{width: "8rem"}}
                        startIcon={<CloseIcon style={{height: "1rem"}} />}
                        onClick={onCancel}
                    >
                        Cancelar
                    </Button>
                </Grid>
                <Grid item textAlign={"right"} marginLeft={"1rem"}>
                    <Button 
                        variant="contained" 
                        color={"primary"}
                        style={{width: "8rem"}}
                        startIcon={<CheckIcon style={{height: "1rem"}} />}
                        disabled={
                            (parentData?.currentChildView === "employees" && employees.length !== 1) 
                            || error !== ""
                        }
                        onClick={() => {
                            switch (parentData?.currentChildView) {
                                case "employees":
                                    handleSaveNewEmployee();
                                    break;
                                case "offices":
                                    handleSaveNewOffice();
                                    break;
                            }
                            // setChildInformation(null);
                            // setNodeAction(null);
                        }}
                    >
                        {nodeAction}
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>)
}

export default AddNodeModal